// extracted by mini-css-extract-plugin
export default {"container":"GUSQO3","suggestion":"mZr9yi","more":"mvEPoD","one":"o_WZGP","action":"UgEnpR"};